import { Ticket } from "../../models/RestModels";

export function getEmptyTicket(): Ticket
{
		return {
			id: 0,
			created: new Date(),
			created_by_user_id: 0,
			calculation_style: 'NORMAL',
			exceptions_display: 'ONLY_IF_PRESENT',
			font_a_columns: 42,
			font_b_columns: 56,
			footer: '',
			header: '',
			image_width: 128,
			item_money_sign_display: 'ONLY_IF_HAS_PRICE',
			item_name_display: 'TRUNCATED',
			item_note_display: 'ALWAYS',
			item_price_display: 'ONLY_IF_HAS_PRICE',
			item_qty1_display: 'NEVER',
			item_qty2_display: 'NEVER',
			item_qty_times_price_display: 'ONLY_IF_HAS_PRICE',
			item_subtotal_display: 'NEVER',
			item_total_display: 'ONLY_IF_HAS_PRICE',
			name: '',
			option_item_display: 'ALWAYS',
			option_price_display: 'ONLY_IF_HAS_PRICE',
			option_qty_by_item: 'ALWAYS',
			option_row_display: 'ALWAYS',
			option_total_qty: 'ONLY_IF_HAS_PRICE',
			option_total_qty_times_price: 'ONLY_IF_HAS_PRICE',
			order_note_display: 'ALWAYS',
			updated: new Date(),
			updated_by_user_id: 0
		};
}
